import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralAxiosError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Invitation } from 'src/features/users/utils/types';

const RESOURCE = `/parkings/:parkingId/invitations/`;

type MutationFnType = typeof mutationFn;
interface DTO {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<Invitation> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralAxiosError<{ email: string[] }>>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateInvitation };
